module.exports = __webpack_public_path__ + "img/Logo Horizontal Color_Beta_Dark.6e76bc0.png";